import { FC, useMemo } from 'react';
import { DigitalFormScopeHooks } from '@frontend/digital-forms-scope';
import { useTranslation } from '@frontend/i18n';
import { ModalControlResponse } from '@frontend/design-system';
import { pendoTags } from '../../../../../../../../shared/constants';
import { PaymentsInFormsOnboardingModal, PaymentsInFormsOnboardingTypes } from '../../../../../../../../shared/hooks';
import { useTemplatesV2Store } from '../../../../../../provider';

export interface PaymentsOnboardingStepProps {
  modalControls: ModalControlResponse;
  hasAtLeastOnePaymentsEnabledLocation: boolean;
  onContinueWithoutOnboardingAllLocations: () => void;
  onGoBack?: () => void;
}

const PaymentsOnboardingStep: FC<PaymentsOnboardingStepProps> = ({
  modalControls,
  hasAtLeastOnePaymentsEnabledLocation,
  onContinueWithoutOnboardingAllLocations,
  onGoBack,
}) => {
  const { t } = useTranslation('forms');
  const { formsEnabledGLSLocationIds } = DigitalFormScopeHooks.useFormsEnabledOrgLocations();
  const { paymentsEnabledLocationIdsMap } = useTemplatesV2Store(['paymentsEnabledLocationIdsMap']);

  const paymentsOnboardingModalTrackingIds = useMemo<PaymentsInFormsOnboardingTypes.TrackingIds>(() => {
    return {
      setUpPayments: pendoTags.templateGallery.paymentsOnboarding.setUpPayments,
      continueWithoutPaymentsOnboardingAllLocations:
        pendoTags.templateGallery.paymentsOnboarding.continueWithoutOnboardingAllLocations,
      cancelPaymentsOnboarding: pendoTags.templateGallery.paymentsOnboarding.cancelOnboarding,
      goBack: pendoTags.templateGallery.paymentsOnboarding.goBackToPreview,
    };
  }, []);

  return (
    <PaymentsInFormsOnboardingModal
      usageContext='form-templates'
      modalControls={modalControls}
      canUsePaymentsField={hasAtLeastOnePaymentsEnabledLocation}
      formsEnabledLocationIds={formsEnabledGLSLocationIds}
      paymentsEnabledLocationIdsMap={paymentsEnabledLocationIdsMap}
      trakingIds={paymentsOnboardingModalTrackingIds}
      onContinueWithoutOnboardingAllLocations={onContinueWithoutOnboardingAllLocations}
      onGoBack={onGoBack}
      goBackBtnLabel={t('Back to preview')}
    />
  );
};

export default PaymentsOnboardingStep;
